import { isMeetingCancelled } from './isMeetingCancelled';
import { isMeetingConfirmed } from './isMeetingConfirmed';

export function isMeetingPending(meeting) {
    if (!meeting) return false;
    return !isMeetingConfirmed(meeting) && !isMeetingCancelled(meeting);
}
